var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false,"appear":""},on:{"enter":_vm.enter,"leave":_vm.leave}},[(_vm.users && !_vm.gameInProgress)?_c('ul',{staticClass:"users-list"},_vm._l((_vm.users),function(user){return _c('li',[_c('button',{staticClass:"button-player-select"},[_vm._v("\n        "+_vm._s(user.first_name)+"\n      ")])])})):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ecf8d5e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UsersList.vue
// module id = null
// module chunks = 